export var MediaImageStudioEventTypes;
(function (MediaImageStudioEventTypes) {
    MediaImageStudioEventTypes["ImageData"] = "imageData";
    MediaImageStudioEventTypes["UploadedFile"] = "uploadedFile";
    MediaImageStudioEventTypes["UploadFileFailed"] = "uploadFileFailed";
    MediaImageStudioEventTypes["Close"] = "close";
})(MediaImageStudioEventTypes || (MediaImageStudioEventTypes = {}));
//# sourceMappingURL=events.types.js.map